exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-item-group{\n  -webkit-box-flex:0;\n          flex:0 1 auto;\n  position:relative;\n  max-width:100%;\n  -webkit-transition:.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  transition:.3s cubic-bezier(0.25, 0.8, 0.5, 1)\n}", ""]);
